import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormatIndentDecrease } from '@styled-icons/material/FormatIndentDecrease';
import { FormatIndentIncrease } from '@styled-icons/material/FormatIndentIncrease';
import { indent, outdent, ToolbarButton } from '@udecode/plate';
import { useMyPlateEditorRef } from '../typescript/plateTypes';
const IndentToolbarButtons = () => {
    const editor = useMyPlateEditorRef();
    return (_jsxs(_Fragment, { children: [_jsx(ToolbarButton, { onMouseDown: (e) => {
                    if (!editor)
                        return;
                    outdent(editor);
                    e.preventDefault();
                }, icon: _jsx(FormatIndentDecrease, {}) }), _jsx(ToolbarButton, { onMouseDown: (e) => {
                    if (!editor)
                        return;
                    indent(editor);
                    e.preventDefault();
                }, icon: _jsx(FormatIndentIncrease, {}) })] }));
};
export default IndentToolbarButtons;
//# sourceMappingURL=IndentToolbarButtons.js.map